import { render, staticRenderFns } from "./tituloSeccion.vue?vue&type=template&id=5709c846&scoped=true&"
import script from "./tituloSeccion.vue?vue&type=script&lang=js&"
export * from "./tituloSeccion.vue?vue&type=script&lang=js&"
import style0 from "./tituloSeccion.vue?vue&type=style&index=0&id=5709c846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5709c846",
  null
  
)

export default component.exports